import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

interface DropCoinBoxProps {
  onClick: () => void;
  disabled?: boolean;
}

const StyledBox = styled(Box)<{ disabled?: boolean }>(({ disabled }) => ({
  backgroundImage: `url("/dropc.png")`,
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  backgroundSize: "contain",
  backgroundColor: "transparent",
  border: "none",

  // 📱 osnovna responsivnost
  width: "clamp(140px, 28vw, 260px)",
  height: "clamp(40px, 9vw, 80px)",

  cursor: disabled ? "not-allowed" : "pointer",
  pointerEvents: disabled ? "none" : "auto",
  transition: "transform 0.2s ease",

  "&:hover": {
    transform: disabled ? "none" : "translateY(-3px)",
  },
  "&:active": {
    transform: disabled ? "none" : "translateY(2px)",
  },
  opacity: disabled ? 0.6 : 1,

  // 🧭 dodatno smanjenje za baš male ekrane
  "@media (max-width: 400px)": {
    width: "clamp(110px, 35vw, 200px)",
    height: "clamp(35px, 10vw, 60px)",
  },
}));

export const DropCoinButton = ({ onClick, disabled }: DropCoinBoxProps) => {
  return <StyledBox onClick={onClick} disabled={disabled} />;
};
